/**
 * Utilidades para el cálculo de estadísticas y peligrosidad de proyectos
 */

/**
 * Calcula el porcentaje de horas consumidas respecto a las previstas
 * @param {Object} perfiles Objeto con los perfiles y sus horas de realidad/previsión
 * @param {Boolean} limitado Si es true, capa el resultado al 100% (comportamiento original)
 * @returns {Number} Porcentaje (0-100+)
 */
export const calcularPorcentajeTiempo = (perfiles, limitado = false) => {
  if (!perfiles) return 0;
  
  const tiempoRealidad = Object.values(perfiles).reduce((a, b) => a + parseFloat(b.realidad || 0), 0);
  const tiempoPrevision = Object.values(perfiles).reduce((a, b) => a + parseFloat(b.prevision || 0), 0);
  
  const pc = tiempoPrevision > 0 ? (tiempoRealidad * 100) / tiempoPrevision : (tiempoRealidad > 0 ? 100 : 0);
  
  if (limitado && (pc > 100 || pc < 0)) return 100;
  
  return pc < 0 ? 100 : (isNaN(pc) ? 0 : pc);
};

/**
 * Calcula el porcentaje de costes consumidos respecto a los previstos
 * @param {Object} totales_costes Objeto con los totales de costes realidad/previsión
 * @param {Boolean} limitado Si es true, capa el resultado al 100% (comportamiento original)
 * @returns {Number} Porcentaje (0-100+)
 */
export const calcularPorcentajeCoste = (totales_costes, limitado = false) => {
  if (!totales_costes) return 0;
  
  const realidadCoste = totales_costes.realidad || 0;
  const previsionCoste = totales_costes.prevision || 0;
  
  const pc = previsionCoste > 0 ? (realidadCoste * 100) / previsionCoste : (realidadCoste > 0 ? 100 : 0);
  
  if (limitado && (pc > 100 || pc < 0)) return 100;
  
  return pc < 0 ? 100 : (isNaN(pc) ? 0 : pc);
};

/**
 * Mapea un porcentaje a un nivel semántico
 * @param {Number} porcentaje 
 * @returns {String} 'success', 'warning', 'orange' o 'danger'
 */
export const mapearPorcentajeANivel = (porcentaje) => {
  if (porcentaje < 50) return "success";
  if (porcentaje < 75) return "warning";
  if (porcentaje < 100) return "orange";
  return "danger";
};
/**
 * Determina el nivel semántico de peligrosidad basado en el uso de recursos (costes)
 * @param {Object} prevision Objeto de previsión del proyecto
 * @returns {String} Nivel: 'success', 'warning', 'orange' o 'danger'
 */
export const obtenerNivelPeligrosidadRecursos = (prevision) => {
  if (!prevision) return "success";
  return mapearPorcentajeANivel(calcularPorcentajeCoste(prevision.totales_costes));
};
